import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import FloatingWA from "@/components/quickwash/FloatingWA";

import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Track from "@/pages/Track";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import PublicBill from "@/pages/PublicBill";
import DashboardLayout from "@/components/quickwash/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import BillNew from "@/pages/BillNew";
import Bills from "@/pages/Bills";
import BillView from "@/pages/BillView";
import Rates from "@/pages/Rates";
import Customers from "@/pages/Customers";
import Reports from "@/pages/Reports";
import Bookings from "@/pages/Bookings";
import Messages from "@/pages/Messages";
import TagLayoutEditor from "@/pages/TagLayoutEditor";

const Protected = ({ children }) => {
  const { user, checking } = useAuth();
  if (checking) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book" element={<Booking />} />
          <Route path="/track" element={<Track />} />
          <Route path="/bill/:ref" element={<PublicBill />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route path="/admin" element={<Protected><DashboardLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="bills/new" element={<BillNew />} />
            <Route path="bills/:id/edit" element={<BillNew />} />
            <Route path="bills" element={<Bills />} />
            <Route path="bills/:id" element={<BillView />} />
            <Route path="rates" element={<Rates />} />
            <Route path="customers" element={<Customers />} />
            <Route path="reports" element={<Reports />} />
            <Route path="bookings" element={<Bookings />} />
            <Route path="messages" element={<Messages />} />
            <Route path="tag-editor" element={<TagLayoutEditor />} />
          </Route>
        </Routes>
        <FloatingWA />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
